import Reducer from "./Reducer";
import { combineReducers } from "redux";
import ReportReducer from "./Report/ReportReducer";
const RootReducer = combineReducers({
  common: Reducer,
  reports: ReportReducer
});

export default RootReducer;
